var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"id":"btnOptimisation","onclick":"location.href='/constructeur_portefeuille/selection_titres'"}},[_c('span',{staticClass:"btnText"},[_vm._v("Optimiser un nouveau portefeuille")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }